import { RouteLocationNormalized } from "vue-router";
import { extraDefinitionResolver } from "./extra_definition.resolver";
import { extraDefinitionValuesResolver } from "./extra_definition_values.resolver";
import { patientResolver } from "./patient.resolver";

export const patientExtraResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        await Promise.all([patientResolver(to, from), extraDefinitionValuesResolver(to, from)])
    } catch(error) {
        console.error('PATIENT_EXTRA_RESOLVER_ERROR');
        return { name: 'Patients' };
    }
}
export const patientExtraDefinitionsResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        await Promise.all([patientResolver(to, from), extraDefinitionResolver(to, from), extraDefinitionValuesResolver(to, from)])
    } catch(error) {
        console.error('PATIENT_EXTRA_RESOLVER_ERROR');
        return { name: 'Patients' };
    }
}